export default __webpack_public_path__ + "static/14.SAAC-7eaaac7ba3b4853bfc0161f150a25b97.png";